/* 布局 */
//前台
import Layout from "@views/layout";

const orderburyRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "orderbury/list",
        name: "ORDERBURY",
        meta: {
            title: "殡葬用品订单主表",
            keepAlive:true
        },
        component: () => import("@views/business/orderbury/index.vue"),
    },
        ],
};

export default orderburyRouter;
